import { ReactElement } from 'react';
import CountUp from 'react-countup';
import { useDispatch } from 'react-redux';

import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import { Theme, Popover, Button, Typography, Divider } from '@mui/material';

import { UserPopoverProps } from './types';

import { useSelector } from '../../../../../../../../common/hooks';
import HStack from '../../../../../../../../components/Stacks/HStack';
import VStack from '../../../../../../../../components/Stacks/VStack';
import { resetState } from '../../../../../../../../store/slices/user';

const formatter = new Intl.NumberFormat('en-GB', {
  style: 'currency',
  currency: 'EUR',
  minimumFractionDigits: 2
});

export default function UserPopover(props: UserPopoverProps): ReactElement {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);

  const { anchorEl, onClose } = props;

  const balance = formatter.format(user.data.balance / 100 || 0);

  const handleLogin = (): void => {
    onClose();

    setTimeout(() => dispatch(resetState()), 250);
  };

  return (
    <>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        onClose={() => onClose()}
        elevation={3}
        sx={{
          '& .MuiPopover-paper': {
            minWidth: '300px',

            zIndex: 1000,

            backgroundColor: 'background.default',
            borderRadius: 2,

            p: 0,
            mt: 2
          },

          '& *': {
            transition: (theme: Theme) =>
              `${theme.transitions?.duration?.shortest}ms ${theme.transitions?.easing?.easeInOut}`
          }
        }}>
        <VStack
          width='100%'
          // justifyContent='center'
          // alignItems='stretch'
          divider={<Divider />}
          spacing={2}
          p={2}>
          <VStack width='100%' spacing={0.5}>
            <Typography align='left' color='textPrimary' fontWeight={500} variant='h5'>
              {user.data.fullname}
            </Typography>
            <HStack width='100%' alignItems='center' justifyContent='flex-start' spacing={0.75}>
              <EmailOutlinedIcon sx={{ color: 'text.secondary', fontSize: '18px' }} />
              <Typography align='left' color='textSecondary' variant='body1'>
                {user.data.email}
              </Typography>
            </HStack>
          </VStack>

          <VStack width='100%' spacing={0.5}>
            <Typography align='left' color='textSecondary' variant='body1'>
              Balance
            </Typography>
            <Typography align='left' color='textPrimary' fontWeight={500} variant='h4'>
              <CountUp
                start={0}
                end={Number(balance.substring(1).replaceAll(',', ''))}
                duration={1}
                prefix={balance.charAt(0)}
              />
            </Typography>
          </VStack>

          <Button color='error' onClick={() => handleLogin()}>
            Log out
          </Button>
        </VStack>
      </Popover>
    </>
  );
}
